import { useState, useMemo } from 'react';
import productsData from '../data/products.json';

export const useProducts = () => {
    const [searchTerm, setSearchTerm] = useState('');

    // Cargar productos del JSON (sin duplicados)
    const products = useMemo(() => {
        const seen = new Set();
        return productsData.products
            .filter(p => {
                if (seen.has(p.id)) return false;
                seen.add(p.id);
                return p.available !== false;
            });
    }, []);

    const filteredProducts = useMemo(() => {
        if (!searchTerm.trim()) return products;

        const term = searchTerm.toLowerCase();
        return products.filter(product =>
            product.name.toLowerCase().includes(term) ||
            product.description.toLowerCase().includes(term)
        );
    }, [products, searchTerm]);

    return {
        products: filteredProducts,
        searchTerm,
        setSearchTerm,
        totalProducts: filteredProducts.length,
        allProducts: products
    };
};
